<div class="persona-juridica-step">
  <p class="main-question"><strong>Persona jurídica</strong></p>
  <p class="subtext">Datos de tu empresa, organización o negocio</p>

  <div class="phase-indicator">
    <span class="phase-badge">Paso {{ subStep }} de 2</span>
  </div>

  <form [formGroup]="form" class="form-wrapper">
    <!-- ==================== SUB-PASO 1: DATOS DE LA EMPRESA ==================== -->
    <ng-container *ngIf="subStep === 1">
      <p class="sub-title"><strong>Datos de la empresa</strong></p>

      <!-- Lo que ya sabemos -->
      <div class="known-card">
        <div class="known-row">
          <span class="known-label">Razón social</span>
          <span class="known-value">{{ form.get('razonSocial')?.value || '—' }}</span>
        </div>
        <div class="known-row">
          <span class="known-label">RUT</span>
          <span class="known-value">{{ form.get('rut')?.value || '—' }}</span>
        </div>
        <div class="known-row">
          <span class="known-label">Teléfono</span>
          <span class="known-value">{{ telefonoCompleto || '—' }}</span>
        </div>

        <p class="known-note">
          <mat-icon>verified</mat-icon>
          La razón social y el RUT vienen del e-RUT que cargaste, y el teléfono es el
          que verificamos por WhatsApp.
        </p>
      </div>

      <!-- Lo que falta -->
      <div class="section-divider"><span>Completa estos datos</span></div>

      <div class="floating-group">
        <input type="text" id="pj_fantasia" formControlName="nombreFantasia" />
        <label for="pj_fantasia">Nombre de fantasía</label>
      </div>
      <p class="field-error" *ngIf="isFieldInvalid('nombreFantasia')">
        Ingresa el nombre de fantasía.
      </p>

      <div class="floating-group">
        <input type="text" id="pj_giro" formControlName="giroComercial" />
        <label for="pj_giro">Giro comercial</label>
      </div>
      <p class="field-error" *ngIf="isFieldInvalid('giroComercial')">
        Ingresa el giro comercial.
      </p>
      <p class="field-hint" *ngIf="signupState.erutAnalysis?.glosaActividad">
        Lo tomamos de la glosa de actividad de tu e-RUT. Corrígelo si no es el
        giro real de la empresa.
      </p>

      <div class="floating-group">
        <input type="date" id="pj_constitucion" formControlName="fechaConstitucion" />
        <label for="pj_constitucion">Fecha de constitución</label>
      </div>
      <p class="field-error" *ngIf="isFieldInvalid('fechaConstitucion')">
        Indica la fecha de constitución.
      </p>

      <div class="actions">
        <button type="button" class="continue-btn" (click)="goToSubStep2()">
          Continuar
        </button>
        <button type="button" class="back-btn" (click)="goBack()">Volver</button>
      </div>
    </ng-container>

    <!-- ==================== SUB-PASO 2: DIRECCIÓN Y RELACIÓN ==================== -->
    <ng-container *ngIf="subStep === 2">
      <p class="sub-title"><strong>Dirección y relación comercial</strong></p>

      <div class="form-grid">
        <div class="floating-group">
          <select id="pj_pais" formControlName="pais">
            <option value="" disabled hidden></option>
            <option *ngFor="let country of countries" [value]="country.name">
              {{ country.name }}
            </option>
          </select>
          <label for="pj_pais">País</label>
        </div>
        <div class="floating-group">
          <input type="text" id="pj_ciudad" formControlName="ciudad" />
          <label for="pj_ciudad">Ciudad</label>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <input type="text" id="pj_comuna" formControlName="comuna" />
          <label for="pj_comuna">Comuna</label>
        </div>
        <div class="floating-group">
          <input type="text" id="pj_oficina" formControlName="oficina" />
          <label for="pj_oficina">N° de oficina (opcional)</label>
        </div>
      </div>

      <div class="floating-group">
        <input type="text" id="pj_direccion" formControlName="direccion" />
        <label for="pj_direccion">Dirección</label>
      </div>

      <p class="field-error" *ngIf="isFieldInvalid('pais') || isFieldInvalid('ciudad') || isFieldInvalid('comuna') || isFieldInvalid('direccion')">
        Completa país, ciudad, comuna y dirección.
      </p>
      <p class="field-hint" *ngIf="signupState.erutAnalysis?.direccion">
        Es la dirección principal que tu empresa tiene registrada en el SII.
        Cámbiala si se mudó.
      </p>

      <div class="floating-group">
        <select id="pj_motivo" formControlName="motivoRelacion2">
          <option value="" disabled hidden></option>
          <option *ngFor="let motivo of motivosRelacion" [value]="motivo.value">
            {{ motivo.label }}
          </option>
        </select>
        <label for="pj_motivo">Motivo de la relación comercial</label>
      </div>
      <p class="field-error" *ngIf="isFieldInvalid('motivoRelacion2')">
        Selecciona el motivo de la relación comercial.
      </p>

      <p class="legal-note">
        Los datos otorgados se utilizarán solo por
        <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido conocimiento
        de sus clientes. No serán divulgados ni puestos en conocimiento público,
        conforme a la Ley N° 19.628 sobre Protección de la Vida Privada.
      </p>

      <div class="actions">
        <button
          type="button"
          class="continue-btn"
          (click)="onSubmit()"
          [disabled]="loading"
        >
          {{ loading ? 'Guardando...' : 'Continuar' }}
        </button>
        <button
          type="button"
          class="back-btn"
          (click)="backToSubStep1()"
          [disabled]="loading"
        >
          Volver
        </button>
      </div>
    </ng-container>
  </form>
</div>
